// Google ,AppleButtonの共通スタイルを定義
export const commonBtnStyles = {
  borderRadius: 10,
  padding: '8px 13px',
  margin: '0 auto',
  fontSize: 11,
}

// ↑の子要素のスタイルを定義
export const commonTypoStyles = {
  display: '-webkit-box',
  wordBreak: 'break-all',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
}
